import React from 'react';
import { useForm } from 'react-hook-form';
import Form from '@/shared/ui/Form/Form';
import PasswordInput from '@/shared/ui/Inputs/PasswordInput';
import StringInput from '@/shared/ui/Inputs/StringInput';
import SelectInput from '@/shared/ui/Inputs/SelectInput';
import Button from '@/shared/ui/Buttons/Button';
import { useNavigate } from 'react-router-dom';
import { EmployeeCreateDTO, EmployeeRole } from '@/shared/api/gen/data-contracts';

const ROLE_CHOICES = [
    { title: 'Admin', value: EmployeeRole.Admin },
    { title: 'Superadmin', value: EmployeeRole.Superadmin },
];

interface EmployeeFormProps {
    defaultData: Partial<EmployeeCreateDTO>;
    onSubmit: (data: any) => void;
    isEdit?: boolean;
}

function EmployeeForm({ defaultData, onSubmit, isEdit = false }: EmployeeFormProps) {
    const navigate = useNavigate();
    const { register, handleSubmit, reset, watch } = useForm<EmployeeCreateDTO>({ defaultValues: defaultData });

    React.useEffect(() => {
        reset(defaultData, { keepDirty: true, keepTouched: true });
    }, [defaultData]);

    const roleValue = watch("role");

    return (
        <Form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '560px' }}>
            <h2 className='text-24'>Карточка сотрудника</h2>
            <StringInput label="ФИО сотрудника" register={register("name", { required: "обязательное поле" })} />
            <StringInput label="Почта" register={register("email", { required: "обязательное поле" })} />
            {!isEdit && (
                <PasswordInput label="Пароль" register={register("password", { required: "обязательное поле" })} />
            )}
            <SelectInput
                key={roleValue}
                label="Роль"
                register={register("role", { required: "обязательное поле" })}
                value={roleValue}
                choices={ROLE_CHOICES}
                default={ROLE_CHOICES[0]}
            />
            <div className='FormRow'>
                <Button type="button" onClick={() => navigate(-1)}>Отмена</Button>
                <Button type="submit">{isEdit ? 'Сохранить' : 'Добавить сотрудника'}</Button>
            </div>
        </Form>
    );
}

export default EmployeeForm;
